export const TEST_INIT = "TEST_INIT";
export const TEST_SUCCESS = "TEST_SUCCESS";
export const TEST_FAIL = "TEST_FAIL";

export const LOGIN_INIT = "LOGIN_INIT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";

export const GET_USER_DATA = "GET_USER_DATA";

export const ADD_SALE_INIT = "ADD_SALE_INIT";
export const ADD_SALE_SUCCESS = "ADD_SALE_SUCCESS";
export const ADD_SALE_FAIL = "ADD_SALE_FAIL";

export const ADD_PURCHASE_INIT = "ADD_PURCHASE_INIT";
export const ADD_PURCHASE_SUCCESS = "ADD_PURCHASE_SUCCESS";
export const ADD_PURCHASE_FAIL = "ADD_PURCHASE_FAIL";

export const ADD_EXPENSE_INIT = "ADD_EXPENSE_INIT";
export const ADD_EXPENSE_SUCCESS = "ADD_EXPENSE_SUCCESS";
export const ADD_EXPENSE_FAIL = "ADD_EXPENSE_FAIL";

export const GET_PAYMENT_INIT = "GET_PAYMENT_INIT";
export const GET_PAYMENT_SUCCESS = "GET_PAYMENT_SUCCESS";
export const GET_PAYMENT_FAIL = "GET_PAYMENT_FAIL";

export const GET_BYID_PAYMENT_INIT = "GET_BYID_PAYMENT_INIT";
export const GET_BYID_PAYMENT_SUCCESS = "GET_BYID_PAYMENT_SUCCESS";
export const GET_BYID_PAYMENT_FAIL = "GET_BYID_PAYMENT_FAIL";

export const ADD_PAYMENT_INIT = "ADD_PAYMENT_INIT";
export const ADD_PAYMENT_SUCCESS = "ADD_PAYMENT_SUCCESS";
export const ADD_PAYMENT_FAIL = "ADD_PAYMENT_FAIL";

export const GET_VENDORS_INIT = "GET_VENDORS_INIT";
export const GET_VENDORS_SUCCESS = "GET_VENDORS_SUCCESS";
export const GET_VENDORS_FAIL = "GET_VENDORS_FAIL";

export const GET_SALE_INIT = "GET_SALE_INIT";
export const GET_SALE_SUCCESS = "GET_SALE_SUCCESS";
export const GET_SALE_FAIL = "GET_SALE_FAIL";

export const UPDATE_SALE_INIT = "UPDATE_SALE_INIT";
export const UPDATE_SALE_SUCCESS = "UPDATE_SALE_SUCCESS";
export const UPDATE_SALE_FAIL = "UPDATE_SALE_FAIL";

export const GET_PURCHASE_INIT = "GET_PURCHASE_INIT";
export const GET_PURCHASE_SUCCESS = "GET_PURCHASE_SUCCESS";
export const GET_PURCHASE_FAIL = "GET_PURCHASE_FAIL";

export const UPDATE_PURCHASE_INIT = "UPDATE_PURCHASE_INIT";
export const UPDATE_PURCHASE_SUCCESS = "UPDATE_PURCHASE_SUCCESS";
export const UPDATE_PURCHASE_FAIL = "UPDATE_PURCHASE_FAIL";

export const GET_EXPENSE_INIT = "GET_EXPENSE_INIT";
export const GET_EXPENSE_SUCCESS = "GET_EXPENSE_SUCCESS";
export const GET_EXPENSE_FAIL = "GET_EXPENSE_FAIL";

export const UPDATE_EXPENSE_INIT = "UPDATE_EXPENSE_INIT";
export const UPDATE_EXPENSE_SUCCESS = "UPDATE_EXPENSE_SUCCESS";
export const UPDATE_EXPENSE_FAIL = "UPDATE_EXPENSE_FAIL";

export const UPDATE_EXPENSES_INIT = "UPDATE_EXPENSES_INIT";
export const UPDATE_EXPENSES_SUCCESS = "UPDATE_EXPENSES_SUCCESS";
export const UPDATE_EXPENSES_FAIL = "UPDATE_EXPENSES_FAIL";

export const GET_USERS_DATA_INIT = "GET_USERS_DATA_INIT";
export const GET_USERS_DATA_SUCCESS = "GET_USERS_DATA_SUCCESS";
export const GET_USERS_DATA_FAIL = "GET_USERS_DATA_FAIL";

export const GET_LOAN_TYPE_INIT = "GET_LOAN_TYPE_INIT";
export const GET_LOAN_TYPE_SUCCESS = "GET_LOAN_TYPE_SUCCESS";
export const GET_LOAN_TYPE_FAIL = "GET_LOAN_TYPE_FAIL";

export const ADD_LOAN_INIT = "ADD_LOAN_INIT";
export const ADD_LOAN_SUCCESS = "ADD_LOAN_SUCCESS";
export const ADD_LOAN_FAIL = "ADD_LOAN_FAIL";

export const GET_LOAN_INIT = "GET_LOAN_INIT";
export const GET_LOAN_SUCCESS = "GET_LOAN_SUCCESS";
export const GET_LOAN_FAIL = "GET_LOAN_FAIL";

export const ADD_ASSETS_INIT = "ADD_ASSETS_INIT";
export const ADD_ASSETS_SUCCESS = "ADD_ASSETS_SUCCESS";
export const ADD_ASSETS_FAIL = "ADD_ASSETS_FAIL";

export const GET_ASSETS_INIT = "GET_ASSETS_INIT";
export const GET_ASSETS_SUCCESS = "GET_ASSETS_SUCCESS";
export const GET_ASSETS_FAIL = "GET_ASSETS_FAIL";

export const ADD_STORE_INIT = "ADD_STORE_INIT";
export const ADD_STORE_SUCCESS = "ADD_STORE_SUCCESS";
export const ADD_STORE_FAIL = "ADD_STORE_FAIL";

export const DELETE_STORE_INIT = "DELETE_STORE_INIT";
export const DELETE_STORE_SUCCESS = "DELETE_STORE_SUCCESS";
export const DELETE_STORE_FAIL = "DELETE_STORE_FAIL";

export const DELETE_PAYMENT_INIT = "DELETE_PAYMENT_INIT";
export const DELETE_PAYMENT_SUCCESS = "DELETE_PAYMENT_SUCCESS";
export const DELETE_PAYMENT_FAIL = "ADD_PAYMENT_FAIL";

export const UPDATE_ASSETS_INIT = "UPDATE_ASSETS_INIT";
export const UPDATE_ASSETS_SUCCESS = "UPDATE_ASSETS_SUCCESS";
export const UPDATE_ASSETS_FAIL = "UPDATE_ASSETS_FAIL";

export const UPDATE_LOAN_INIT = "UPDATE_LOAN_INIT";
export const UPDATE_LOAN_SUCCESS = "UPDATE_LOAN_SUCCESS";
export const UPDATE_LOAN_FAIL = "UPDATE_LOAN_FAIL";

export const ADD_VENDORS_INIT = "ADD_VENDORS_INIT";
export const ADD_VENDORS_SUCCESS = "ADD_VENDORS_SUCCESS";
export const ADD_VENDORS_FAIL = "ADD_VENDORS_FAIL";

export const DELETE_VENDORS_INIT = "DELETE_VENDORS_INIT";
export const DELETE_VENDORS_SUCCESS = "DELETE_VENDORS_SUCCESS";
export const DELETE_VENDORS_FAIL = "DELETE_VENDORS_FAIL";

export const ADD_TRANSFER_INIT = "ADD_TRANSFER_INIT";
export const ADD_TRANSFER_SUCCESS = "ADD_TRANSFER_SUCCESS";
export const ADD_TRANSFER_FAIL = "ADD_TRANSFER_FAIL";

export const GET_TRANSFER_INIT = "GET_TRANSFER_INIT";
export const GET_TRANSFER_SUCCESS = "GET_TRANSFER_SUCCESS";
export const GET_TRANSFER_FAIL = "GET_TRANSFER_FAIL";

export const DELETE_TRANSFER_INIT = "DELETE_TRANSFER_INIT";
export const DELETE_TRANSFER_SUCCESS = "DELETE_TRANSFER_SUCCESS";
export const DELETE_TRANSFER_FAIL = "ADD_TRANSFER_FAIL";

export const UPDATE_VENDORS_INIT = "UPDATE_VENDORS_INIT";
export const UPDATE_VENDORS_SUCCESS = "UPDATE_VENDORS_SUCCESS";
export const UPDATE_VENDORS_FAIL = "UPDATE_VENDORS_FAIL";

export const UPDATE_TRANSFER_INIT = "UPDATE_TRANSFER_INIT";
export const UPDATE_TRANSFER_SUCCESS = "UPDATE_TRANSFER_SUCCESS";
export const UPDATE_TRANSFER_FAIL = "UPDATE_TRANSFER_FAIL";

export const UPDATE_USER_INIT = "UPDATE_USER_INIT";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const UPDATE_PAYMENT_INIT = "UPDATE_PAYMENT_INIT";
export const UPDATE_PAYMENT_SUCCESS = "UPDATE_PAYMENT_SUCCESS";
export const UPDATE_PAYMENT_FAIL = "UPDATE_PAYMENT_FAIL";

export const FORGOT_PASSWORD_INIT = "FORGOT_PASSWORD_INIT";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const RESET_PASSWORD_INIT = "RESET_PASSWORD_INIT";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

